import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { Rating } from "@pages/Dashboard/features/Products/Rating";
import { CollapseInfo } from "@pages/MarketIntelligence/components/CollapseInfo";
import { AsinBtn } from "../asinBtn";
import { statuses, capitalize } from "./statuses";
import classNames from "classnames";
import BottomArrow from "@assets/icons/bottomArrow";
import { ItemData } from "../../types";

export const Card = ({
  asin,
  title,
  img,
  rating,
  isVariants,
  setIsVariants,
  isVariant,
  variantsCount,
  isTable,
  setIsDetails,
  isDetails,
  status,
}: ItemData) => {
  const [currentStatus, setCurrentStatus] = useState(status.toLowerCase());
  const [isStatusOpen, setIsStatusOpen] = useState(false);

  useEffect(() => {
    if (status.toLowerCase() !== currentStatus) {
      setCurrentStatus(status.toLowerCase());
    }
  }, [status]);

  const toggleStatusOpen = () => {
    setIsStatusOpen((prev) => !prev);
  };

  const handleStatusChange = (newStatus: string) => {
    setCurrentStatus(newStatus);
    setIsStatusOpen(false);
  };

  return (
    <div className={styles.productCard}>
      <div className={styles.cardContent}>
        <img src={img} alt="" />
        <div className={styles.content}>
          <h3>{title}</h3>
          {asin && <AsinBtn asin={asin} />}
          {rating > 0 && <Rating rating={rating} starSize="sm" asin={asin} />}
        </div>
      </div>

      {!isVariant && variantsCount > 0 && (
        <CollapseInfo
          label="Variants"
          count={variantsCount}
          onClick={() => setIsVariants(!isVariants)}
          rotateArrow={isVariants}
        />
      )}

      <div className={styles.additionalActions}>
        <button
          type="button"
          className={classNames(styles.track, styles[currentStatus], {
            [styles.open]: isStatusOpen,
          })}
          onClick={toggleStatusOpen}
          ref={useRef<HTMLButtonElement>(null)}
        >
          <div className={styles.trackWrapper}>
            <span className={styles.trackText}>
              <span className={styles.trackIcon}></span>
              {capitalize(currentStatus)}
            </span>
            <span className={styles.arrow}>
              <BottomArrow fill={currentStatus === "active" ? "#80C67A" : ""} />
            </span>
          </div>
        </button>

        {isStatusOpen && (
          <div className={styles.statusDropdown}>
            {statuses.map((statusItem) => (
              <button
                key={statusItem.code}
                type="button"
                className={classNames(
                  styles.statusOption,
                  styles[statusItem.code],
                )}
                onClick={() => handleStatusChange(statusItem.code)}
              >
                <span className={styles.trackIcon}></span>
                {statusItem.label}
              </button>
            ))}
          </div>
        )}

        {!isTable && (
          <CollapseInfo
            label="Details"
            onClick={() => setIsDetails(!isDetails)}
            rotateArrow={isDetails}
          />
        )}
      </div>
    </div>
  );
};
